import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Component that redirects the user to a specified endpoint with path, search, and hash matching
 * the current page.
 * Designed for use as a catch-all route that will automatically redirect the user.
 */
export const CatchAllRedirect: React.FC<CatchAllRedirectProps> = ({ redirectOrigin }) => {
  const location = useLocation();

  window.location.href = `${redirectOrigin}${location.pathname}${location.search}${location.hash}`;

  return null;
};

/** Props passed to initialize a {@link CatchAllRedirect} componet */
export interface CatchAllRedirectProps {
  /**
   * Origin where users should be redirected. Must include the scheme followed by the domain and port number.
   * e.g. https://redirect-here:3000
   */
  redirectOrigin: string;
}

export default CatchAllRedirect;
